module.exports = __webpack_public_path__ + "media/images/games/35gender/pilot-c9842de7eb364d904db94407ee475af0.png";